import { Record } from 'immutable'
import { Address, IAddress } from './Address'
import { Area, IArea } from './Area'

export interface IComp {
  readonly lastSaleDate?: number
  readonly lastSalePrice?: number
  readonly propertyAddress: IAddress
  readonly propertyId: string
  readonly propertyName: string
  readonly propertySize: IArea
}

const PropertyCompRecord = Record({
  lastSaleDate: undefined,
  lastSalePrice: undefined,
  propertyAddress: new Address(),
  propertyId: '',
  propertyName: '',
  propertySize: new Area(),
})

export class Comp extends PropertyCompRecord implements IComp {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Comp()
    }

    const { propertyAddress, propertySize, ...rest } = initialState
    return new Comp({
      propertyAddress: Address.fromJS(propertyAddress),
      propertySize: Area.fromJS(propertySize),
      ...rest,
    })
  }

  public readonly lastSaleDate?: number
  public readonly lastSalePrice?: number
  public readonly propertyAddress: Address
  public readonly propertyId: string
  public readonly propertyName: string
  public readonly propertySize: Area

  constructor(props?: Partial<Comp>) {
    props ? super(props) : super()
  }
}
